<template>
  <CustomCallout
    ref="callout"
    class="mt-2 deep"
    :class-main="
      getEvaluationBackgroundClass(model.sourceId, model.isDiscussionPending)
    "
    :has-toggle="true"
    :controlled="true"
    :opened="isOpen"
    :hex-colors-wrap-icon="'#f7f7f7'"
    :border-color-hex="getEvaluationStatusColor(model.statusId)"
    @click:open="toggleCallout()"
  >
    <div class="row mt-2 pb-3">
      <div class="col-12 col-md-2 col-lg-2 pt-3 pl-q my-auto">
        <div
          class="row h-50"
          :class="{
            ' mx-auto justify-content-center center-balloon': isMobile,
          }"
        >
          <div class="balloon-container">
            <CustomBalloon
              class="px-5 pt-2 pb-2"
              :text="evaluationStatus"
              :background-color="
                `${getEvaluationStatusColor(model.statusId, false)} color-black`
              "
              dot
            />
          </div>
        </div>
      </div>

      <div
        class="col-md-7 col-lg-7 pt3"
        :class="{
          'divider-horizontal my-auto': !isMobile,
          'divider-vertical mx-auto': isMobile,
        }"
      >
        <div :class="['row', { 'pt-2': isMobile }]">
          <div class="col-12 col-md-4 d-flex flex-column mb-2 mb-md-2">
            <CustomInputDisplay
              label="Nombre del Estudiante:"
              label-class="text-gray font-weight-light"
              :value="studentFullName"
              class="font-weight-bold"
            />
          </div>

          <div class="col-12 col-md-4 d-flex flex-column mb-3 mb-md-2">
            <CustomInputDisplay
              label="Tipo de Evaluación:"
              label-class="text-gray font-weight-light"
              :value="evaluationType"
              class="font-weight-bold"
            />
          </div>

          <div class="col-12 col-md-4 d-flex flex-column mb-3 mb-md-2">
            <CustomInputDisplay
              label="Disciplina:"
              label-class="text-gray font-weight-light"
              :value="disciplineType"
              class="font-weight-bold"
            />
          </div>

          <div class="col-12 col-md-4 d-flex flex-column mb-3 mb-md-2">
            <CustomInputDisplay
              label="Fecha de Evaluación:"
              label-class="text-gray font-weight-light"
              :value="evaluationDate"
              class="font-weight-bold"
            />
          </div>

          <div class="col-12 col-md-4 d-flex flex-column mb-3 mb-md-2">
            <CustomInputDisplay
              label="Termino de Vencimiento:"
              label-class="text-gray font-weight-light"
              :value="expirationTerm"
              class="font-weight-bold"
            />
          </div>

          <div class="col-12 col-md-4 d-flex flex-column mb-3 mb-md-2">
            <template v-if="reevaluationDueDate">
              <div class="input-display">
                <label class="text-gray font-weight-light">
                  Fecha de Vencimiento:
                </label>

                <div class="position-relative">
                  <label class="due-date-label">
                    <strong>{{ reevaluationDueDate }}</strong>
                  </label>
                </div>
              </div>
            </template>

            <template v-else>
              <CustomInputDisplay
                label="Fecha de Vencimiento:"
                label-class="text-gray font-weight-light"
                :value="null"
                class="font-weight-bold"
              />
            </template>
          </div>
        </div>
      </div>
      <div v-if="!isMobile" class="col-12 col-md-3 pt-3 my-auto">
        <div class="d-flex">
          <Dropdown
            class="mr-3"
            name="Actions"
            :title="'Acciones'"
            :items="commentActions"
          />
          <Dropdown name="Actions" :title="'Acciones'" :items="itemActions" />
        </div>
        <div
          v-if="timeToExpiration"
          :class="['d-flex', 'section-time-expiration']"
        >
          <label
            v-if="shouldShowPendingDays"
            class="text-gray font-weight-light"
          >
            Días pendientes para vencimiento:
            <span class="time-to-expiration-text">
              {{ timeToExpiration }}
            </span>
          </label>
        </div>
      </div>

      <div v-if="isMobile" class="col-12 col-md-2 pt-3 my-auto">
        <template v-if="timeToExpiration">
          <div
            :class="['row d-flex', 'resizer-pendant', { 'ml-2': isMobile }]"
            v-if="shouldShowPendingDays"
          >
            <label class="text-gray font-weight-light">
              Días pendientes para vencimiento:
              <span class="time-to-expiration-text">
                {{ timeToExpiration }}
              </span>
            </label>
          </div>
        </template>
        <div
          :class="[
            'row d-flex justify-content-end w-100 h-75',
            { 'ml-0': isMobile },
          ]"
        >
          <Dropdown
            :class="[{ 'w-100': isMobile }]"
            name="CommentActions"
            :title="'Acciones'"
            :items="commentActions"
          />
          <Dropdown
            :class="[{ 'w-100': isMobile }]"
            name="Actions"
            :title="'Acciones'"
            :items="itemActions"
          />
        </div>
      </div>
    </div>
    <template #edition>
      <div class="additional-container">
        <div class="p2 mt-1">
          <div class="bg-gray p-2">
            <div class="bg-white p-3 rounded pl-c-xl">
              <CustomTab
                style="overflow: hidden"
                content-class="mt-3"
                :no-nav-style="true"
                nav-class="nav-vue-underline"
                :default-active-tab="activeCustomTab"
              >
                <CustomTabItem
                  title="Información de Contacto"
                  class="mt-2"
                  lazy
                >
                  <div class="row additional-info pb-3 px-3">
                    <div class="col-sm-12 col-md-3 col-lg-3">
                      <label class="text-gray font-weight-light">Nombre:</label>
                      <br />
                      <p>
                        {{ student.contactName }}
                      </p>
                    </div>
                    <div class="col-sm-12 col-md-3 col-lg-3">
                      <label class="text-gray font-weight-light">
                        Parentesco:
                      </label>
                      <br />
                      <p>
                        {{ student.contactRelationName }}
                      </p>
                    </div>
                    <div class="col-sm-12 col-md-3 col-lg-3">
                      <label class="text-gray font-weight-light">
                        Correo electrónico:
                      </label>
                      <br />
                      <p>
                        {{ student.contactEmail }}
                      </p>
                    </div>
                    <div class="col-sm-12 col-md-3 col-lg-3">
                      <label class="text-gray font-weight-light">
                        Teléfono:
                      </label>
                      <br />
                      <p>{{ student.contactTelephone | phone }}</p>
                    </div>
                  </div>
                </CustomTabItem>

                <template v-if="showGeneralInformationTab">
                  <CustomTabItem
                    class="mt-2"
                    title="Información de Evaluación"
                    @click="fetchGeneralInformation"
                  >
                    <GeneralInformation :value="generalInformation" />
                  </CustomTabItem>
                </template>

                <CustomTabItem
                  v-if="showAppointmentInformationTab"
                  title="Información de Cita Recomendada"
                  class="mt-2"
                  @click="fetchAppointmentInformation"
                >
                  <AppointmentInformation :value="appointmentInformation" />
                </CustomTabItem>

                <template v-if="showAppointmentHistoryTab">
                  <CustomTabItem class="mt-2" title="Historial de Citas">
                    <AppointmentEvaluationHistory
                      :items="value.appointmentHistory"
                    />
                  </CustomTabItem>
                </template>
              </CustomTab>
            </div>
          </div>
        </div>
      </div>
    </template>
  </CustomCallout>
</template>

<script>
import CustomCallout from 'custom-callout';
import CustomBalloon from 'custom-balloon';
import { CustomTab, CustomTabItem } from 'custom-tabs';
import Dropdown from 'dropdown';
import CustomInputDisplay from 'CustomInputDisplay';
import GeneralInformation from './GeneralInformation.vue';
import AppointmentInformation from './AppointmentInformation.vue';
import AppointmentEvaluationHistory from './AppointmentEvaluationHistory.vue';
import commentCategories from '@/utils/constants/comment/commentTypes';
import viewTypes from '@/utils/constants/comment/CodeViewTypes.js';

import {
  getEvaluationStatusColor,
  getEvaluationBackgroundClass,
  evaluationStatusCodes,
  appointmentStatusCodes,
} from '@/utils/constants/evaluation-discussion/evaluationStatusCodes';
import {
  getGeneralInformation as _getGeneralInformation,
  getAppointmentInformation as _getAppointmentInformation,
} from '@/modules/student-evaluations-discussion/api.js';
import { revertExcludedStatus as _revertExcludedStatus } from '@/modules/student-evaluations/api';
import moment from 'moment';
import alertMixin from '@/mixin/alert.mixin';
import store, { modulesName } from '@/store';

const StatusTypes = Object.freeze({
  Pending: 1,
  Approve: 2,
  Accomplished: 4,
  Exclude: 5,
});

export default {
  name: 'ResultRow',
  mixins: [alertMixin],
  components: {
    CustomCallout,
    CustomBalloon,
    Dropdown,
    CustomTab,
    CustomTabItem,
    CustomInputDisplay,
    GeneralInformation,
    AppointmentEvaluationHistory,
    AppointmentInformation,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      student: {},
      getEvaluationStatusColor,
      getEvaluationBackgroundClass,
      isOpen: false,
      loaded: false,
      activeCustomTab: 0,
      customTabItems: {
        generalInformation: 0,
        recommendedAppointmentInformation: 1,
        appointmentHistory: 2,
      },
      generalInformation: {
        administeredBy: null,
        appointmentDate: null,
        appointmentNumber: null,
        comment: null,
        csee: null,
        municipality: null,
        provider: null,
        requestedBy: null,
        serviceLocation: null,
        source: null,
        sourceId: null,
        specialist: null,
      },
      appointmentHistory: [],
      appointmentInformation: {
        appointmentDate: null,
        appointmentNumber: null,
        comment: null,
        csee: null,
        municipality: null,
        provider: null,
        serviceLocation: null,
        specialist: null,
      },
    };
  },
  computed: {
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
    model() {
      return this.value;
    },
    shouldGoToReadOnly() {
      return this.model?.placementCommitteeId > 0;
    },
    commentActions() {
      const actions = [];
      if (this.value.studentSie) {
        actions.push({
          label: 'Comentario',
          icon: 'fas fa-file-alt text-green',
          click: async () => {
            const hasDifferentStudentSelected = store.state.$_student
              .selectedStudent
              ? true &&
                store.state.$_student.selectedStudent.studentId.toString() !==
                  this.value.studentSie.toString()
              : false;
            let response;
            if (hasDifferentStudentSelected) {
              response = await this.ShowCancelModal(
                'Atención',
                'El sistema detectó que se cambió el estudiante, usted será redireccionado al menú principal. ¿Está seguro que desea continuar?',
                'Sí',
                'No'
              );
            }
            if (response || !hasDifferentStudentSelected) {
              this.$router.push({
                name: 'studentAddComment',
                params: {
                  commentDate: new Date(),
                  studentSieId: this.value.studentSie,
                  categoryId: commentCategories.DiscusionDeEvaluaciones,
                  codeViewTypeId: viewTypes.AnadirComentario,
                },
              });
            } else {
              return false;
            }
          },
        });
      }

      return actions;
    },
    itemActions() {
      const actions = [];

      actions.push({
        label: 'Entrar',
        icon: 'fas fa-clipboard-check color-primary-1',
        click: () => this.goToEvaluation(),
      });

      if (this.showAppointmentHistoryTab) {
        actions.push({
          label: 'Historial de Citas',
          icon: 'fas fa-history color-primary-1',
          click: () => this.goToAppointmentHistory(),
        });
      }

      var hasPermissionToRevertStatus = this.userHasPermissions(
        'academic.student.evaluationdiscussion.revert.excludestatus'
      );
      if (
        hasPermissionToRevertStatus &&
        this.model.statusId == evaluationStatusCodes.excluded
      ) {
        actions.push({
          label: 'Regresar Estatus',
          icon: 'fas fa-reply-all color-primary-1',
          click: () => this.revertStatus(),
        });
      }

      return actions;
    },
    studentFullName() {
      return this.model.studentFullName;
    },
    evaluationType() {
      return this.model.evaluationType;
    },
    disciplineType() {
      return this.model.disciplineType;
    },
    evaluationDate() {
      return moment(this.model.evaluationDate).format('DD/MMM/YYYY');
    },
    expirationTerm() {
      return this.model.reevaluationPeriod;
    },
    reevaluationDueDate() {
      return this.model.reevaluationDueDate
        ? moment(this.model.reevaluationDueDate).format('DD/MMM/YYYY')
        : null;
    },
    isAccomplishedEvaluation() {
      return this.model.statusId === evaluationStatusCodes.accomplished;
    },
    evaluationStatus() {
      if (this.model.appointmentStatus) {
        if (this.isAccomplishedEvaluation) {
          return this.model.status.toString();
        }
        return `${this.model.status} - ${this.model.appointmentStatus}`;
      }
      return this.model.status || '-';
    },
    timeToExpiration() {
      return this.model.timeToExpiration;
    },
    shouldShowPendingDays() {
      return this.model.statusId == StatusTypes.Pending;
    },
    showGeneralInformationTab() {
      return (
        this.model.statusId != evaluationStatusCodes.acceptedCoordinated &&
        this.model.statusId != evaluationStatusCodes.accomplished
      );
    },
    showAppointmentInformationTab() {
      return (
        this.model.recommended &&
        this.model.studentReferralId &&
        this.model.appointmentStatusId != appointmentStatusCodes.approved
      );
    },
    showAppointmentHistoryTab() {
      return !!this.model.appointmentHistory?.length;
    },
    appointmentHistoryTab() {
      return this.customTabItems.appointmentHistory;
    },
  },
  methods: {
    async revertStatus() {
      const confirmed = await this.ShowCancelModal(
        'Confirmación',
        '¿Está seguro que desea regresar el estatus de la evaluación?',
        'Sí',
        'No'
      );
      if (!confirmed) return;
      try {
        await _revertExcludedStatus(this.model.id);
        this.ShowToast(
          '',
          'La información ha sido guardada exitosamente.',
          'success'
        );
        this.$emit('refresh-search');
      } catch (err) {
        if (err?.response?.data?.message) {
          this.ShowToast('Error', err.response.data.message, 'error');
        } else {
          this.ShowToast('Error', err.message, 'error');
        }
      }
    },
    async getContactInformation() {
      const { studentSie } = this.model;
      let self = this;
      await self
        .$ApiGet(`/api/student/${studentSie}/ContactInformation`)
        .then((res) => {
          if (res.data) {
            const data = res.data;
            this.student = data;
          }
        });
    },
    async toggleCallout() {
      this.isOpen = !this.isOpen;
      if (!this.isOpen || this.loaded) return;

      this.loaded = this.isOpen;

      await this.fetchGeneralInformation();
      await this.getContactInformation();
    },
    async fetchGeneralInformation() {
      const { id } = this.model;
      const { data } = await _getGeneralInformation(id);

      this.generalInformation = { ...data };
    },
    async fetchAppointmentInformation() {
      const { data } = await _getAppointmentInformation(
        this.model.studentReferralId
      );

      this.appointmentInformation = data;
    },
    goToEvaluation() {
      const { studentSie, placementCommitteeId, statusId } = this.model;
      const hasDownloadDocumentAvailable = statusId == 1;
      let path = `/student/evaluationdiscuss/${studentSie}`;
      if (this.shouldGoToReadOnly) {
        path += `/${placementCommitteeId}`;
      }
      path = `${path}?documents=${
        hasDownloadDocumentAvailable ? 'download' : ''
      }`;
      this.$router.push({ path: path });
    },
    async goToAppointmentHistory() {
      this.activeCustomTab = this.appointmentHistoryTab;
      await this.toggleCallout();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .discussion-pending {
    background-color: #fff8e3;
  }

  .reevaluation-recommended {
    background-color: #ffebeb !important;
  }
}

.input-display {
  margin-left: 1rem;
}

.input-display label:first-child {
  margin-bottom: 0;
}

.input-display label:last-child {
  font-weight: normal;
}

.due-date-label {
  color: #ff7058;
  border: 0.063rem solid #ff5b5c;
  border-radius: 1.25rem;
  padding: 0.313rem;
  font-size: 14px;
  //font-weight: bold;
  padding-left: 20px;
  padding-right: 20px;
}

.time-to-expiration-text {
  color: #000;
}
.section-time-expiration {
  margin-top: 26px;
}

.divider-horizontal {
  border-left: 1px solid #e2e2e2;
}

.divider-vertical {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #e2e2e2;
}

.center-balloon {
  position: relative;
  left: -10px;
}
.balloon-container {
  margin-left: auto;
  margin-right: auto;
}
.resizer-pendant {
  margin-top: -15px;
  padding-left: 7px;
}
</style>
